import {
  DEFAULT_AUTH,
  LOGIN_ERROR,
  LOGIN_LAWYER,
  LOGIN_SUCCESS,
  LOGOUT,
  REFRESH_SUCCESS
} from './constants'
import { AuthState } from './models'

export const initialState: AuthState = {
  sending: false,
  loginError: null,
  token: null,
  refreshToken: null,
  id: null,
  role: null
}

export default function auth(
  state = initialState,
  { type, payload }: { type: string; payload?: any }
): AuthState {
  switch (type) {
    case LOGIN_LAWYER:
    case LOGIN_SUCCESS:
    case LOGIN_ERROR:
    case REFRESH_SUCCESS:
      return { ...state, ...payload }

    case DEFAULT_AUTH:
    case LOGOUT:
      return { ...initialState }

    default:
      return state
  }
}
